import classNames from 'classnames';
import './UniversalButton.scss';

const UniversalButton = (
  {
    type = 'button',
    label,
    href,
    size,
    isDisabled,
    isFullWidth,
    isRounded = 'none',
    labelColor,
    labelHoverColor,
    backgroundColor,
    backgroundHoverColor,
    isBordered,
    isHoverBordered,
    borderColor,
    borderHoverColor,
    leftIcon,
    centerIcon,
    rightIcon,
    onClick,
    style,
    premium,
    className,
    unstyled,
    ...props
  }) => {
  const buttonStyles = classNames({
    'button': true,
    'buttonDisabled': isDisabled,

    'buttonSizeSmall': size === 'sm',
    'buttonSizeMiddle': size === 'md',
    'buttonSizeLarge': size === 'lg',
    'buttonFullWidth': isFullWidth,

    'buttonIcon': !!centerIcon,

    'buttonRoundedSmall': isRounded === 'sm',
    'buttonRoundedMiddle': isRounded === 'md',
    'buttonRoundedLarge': isRounded === 'lg',

    'buttonBorderedSmall': isBordered === 'sm',
    'buttonBorderedMiddle': isBordered === 'md',

    'buttonHoverBorderedSmall': isHoverBordered === 'sm',

    'buttonLabelColorWhite': labelColor === 'white',
    'buttonLabelColorBlue': labelColor === 'blue',

    'buttonLabelColorHoverWhite': labelHoverColor === 'white',
    'buttonLabelColorHoverBlue': labelHoverColor === 'blue',

    'buttonBorderColorWhite': borderColor === 'white',
    'buttonBorderColorGray2': borderColor === 'gray2',

    'buttonBorderColorHoverWhite': borderHoverColor === 'white',
    'buttonBorderColorHoverGray2': borderHoverColor === 'grey2',

    'buttonBackgroundColorWhite': backgroundColor === 'white',
    'buttonBackgroundColorOrange': backgroundColor === 'orange',
    'buttonBackgroundColorGray6': backgroundColor === 'gray6',
    'buttonBackgroundColorBlue': backgroundColor === 'blue',

    'buttonBackgroundHoverColorWhite': backgroundHoverColor === 'white',
    'buttonBackgroundHoverColorOrangeLight': backgroundHoverColor === 'orange-light',
    'buttonBackgroundHoverColorBlueLight': backgroundHoverColor === 'blue-light',
    'buttonBackgroundHoverColorGray5': backgroundHoverColor === 'gray5',

    'buttonUnstyled': !!unstyled,
  }, className);

  const handleClick = event => {
    if (!isDisabled) {
      if (href) {
        window.location.href = href;
      } else {
        onClick?.(event);
      }
    }
  };

  return (
    <button
      type={type}
      disabled={isDisabled}
      className={buttonStyles}
      onClick={handleClick}
      style={style}
      {...props}
    >
      {!!leftIcon &&
        <span className='icon--left'>
          {leftIcon}
        </span>
      }

      {!!centerIcon &&
        <span className='icon--center'>
          {centerIcon}
        </span>
      }

      {label &&
        <span>
          {label}
        </span>
      }

      {
        premium ?
          <span className='icon--premium'></span> :
          !!rightIcon &&
          <span className='icon--right'>
           {rightIcon}
          </span>
      }
    </button>
  );
};

export default UniversalButton;
